/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

import { Modal, Card, Table, message, Form, Button } from "antd";
import { Row, Col, Space, Spin, Flex, Checkbox } from "antd";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";

import { columns } from "./model";
import OptionService from "../../../../service/ERP/Options.service";
import { BsUiChecks } from "react-icons/bs";
import { TagItemTypes } from "../../../badge-and-tag/ERP";

const CheckboxGroup = Checkbox.Group;

const options = [
  { value: "Finished Goods", label: "Finished Goods" },
  { value: "Work Instruction", label: "Work Instruction" },
  { value: "Raw Material", label: "Raw Material" },
  { value: "Ingredients", label: "Ingredients" },
  { value: "Packing", label: "Packing" },
  { value: "Packaging", label: "Packaging" },
];

export default function ModalBuyMaterial({ show, close, values,selected,supcode}) {
  const optionService = OptionService();
  const [form] = useForm();
  const inputRef = useRef(null);
  const [modalData, setModalData] = useState([]);
  const [modalDataWrap, setModalDataWrap] = useState([]);

  const [openModal, setOpenModel] = useState(show);
  const [loading, setLoading] = useState(true);
  const [onLoaded, setOnLoaded] = useState(false);

  const [itemsList, setItemsList] = useState(selected || []);
  const [itemsRowKeySelect, setItemsRowKeySelect] = useState([]);

  // const [rowKeySelect, setRowKeySelect] = useState([]);
  const [checkedList, setCheckedList] = useState(options.map((option) => option.value)); // Default check all options
  const [itemsTypeOption, setItemTypeOption] = useState([]);

  const checkAll = itemsTypeOption.length === checkedList.length; // ตรวจสอบว่าเลือกทั้งหมดหรือไม่
  const indeterminate =
    checkedList.length > 0 && checkedList.length < itemsTypeOption.length;

  const onChange = (list) => {
    setCheckedList([...list]);
  };

  const onCheckAllChange = (e) => {
    const all = e.target.checked ? itemsTypeOption.map((m) => m.value) : [];
    setCheckedList([...all]);
  };

  /** handle logic component */
  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleSearch = (value) => {
    const types = [...checkedList];

    if (!!value) {
      const f = modalData.filter((d) => {
        const text =
          d.stcode?.toLowerCase().includes(value?.toLowerCase()) ||
          d.stname?.toLowerCase().includes(value?.toLowerCase());
        const type = types.includes(d.typename);
        return text && type;
      });
      setModalDataWrap(f);
    } else {
      const f = modalData.filter((d) => {
        const type = types.includes(d.typename);
        return type;
      });
      setModalDataWrap(f);
    }
  };

  const handleSelectItems = (record) => {
    const newData = {
      ...record,
      qty: 1,
      percent: 0,
      totalpercent: 0,
    };
    // console.log(newData);

    setItemsList([...itemsList, newData]);
  };

  const handleCheckDuplicate = (itemCode) =>
    !!selected.find((item) => item?.stcode === itemCode);

  const handleConfirm = () => {
    // console.log(selected);
    const choosed = selected.map((m) => m.stcode);
    const itemsChoose = modalData
      .filter(
        (f) =>
          itemsRowKeySelect.includes(f.stcode) && !choosed.includes(f.stcode)
      )
      .map((m, i) => {
        const purchase_type = m.purchase_type === "LOT" ? "LOT" : "QTY";
        const lots = m.lots || [];
        const firstLot = purchase_type === "LOT" ? lots[0] : null;
        const qty =
          purchase_type === "LOT"
            ? Number(firstLot?.lot_size || 0)
            : Number(m.min_qty || 1);
        const price =
          purchase_type === "LOT" && firstLot?.lot_size
            ? Number(firstLot.lot_price) / Number(firstLot.lot_size)
            : Number(m.price || 0);

        return {
          stcode: m.stcode,
          stname: m.stname,
          typename: m.typename,
          purchase_type,
          min_qty: m.min_qty || null,
          lots,
          price,
          qty,
          lot_size: firstLot?.lot_size || null,
          percent: 0,
          unit: m.unit,
          discount: 0,
          recamount: 0,
          shelf_life: m.shelf_life || 0,
        };
      });

    // console.log(itemsChoose, choosed);

    values([...selected, ...itemsChoose]);

    setItemsList([]);
    close(false);
  };

  /** setting initial component */
  const column = columns({ handleSelectItems, handleCheckDuplicate });

  useEffect(() => {
    if (onLoaded) {
      setLoading(true);
      setTimeout(() => {
        const value = inputRef.current?.input.value;
        handleSearch(value);

        setLoading(false);
      }, 200);
    }
  }, [checkedList]);

  useEffect(() => {
    const onload = () => {
      setLoading(true);
      // alert(cuscode)
      optionService
        .optionsBuyMaterial({supcode: supcode , typename: checkedList })
        .then(async (res) => {
          let { data } = res.data;
          setModalData(data);
          setModalDataWrap(data);
          // console.log(modalData, data)
          // const keySelected = selected.map((m) => m.code);
          const allOptions = options.map((m) => ({
            label: <TagItemTypes data={m.value} />,
            value: m.value,
          }));
          setItemTypeOption(allOptions);
          setCheckedList([...allOptions.map(m=>m.value)]);                

        })
        .catch((err) => {
          message.error("Request error!");

          // setLoading(false);
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
            setOnLoaded(true);
          }, 400)
        );
    };
    if (!!openModal) {
      onload();

      // console.log("modal-packages")
    }
  }, [openModal]);

   /** Config Conponent */

  const itemSelection = {
    selectedRowKeys: itemsRowKeySelect,
    type: "checkbox",
    fixed: true,
    // hideSelectAll: false,

    onChange: (selectedRowKeys, selectedRows) => {
      setItemsRowKeySelect([
        ...new Set([...selectedRowKeys, ...itemsRowKeySelect]),
      ]);
      setItemsList(selectedRows);
      setItemsRowKeySelect(selectedRowKeys);
    },
    getCheckboxProps: (record) => {
      return {
        disabled: handleCheckDuplicate(record.stcode),
        name: record.stcode,
      };
    },
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      //console.log(record, selected, selectedRows, nativeEvent);
      if (selected) {
        setItemsRowKeySelect([
          ...new Set([...itemsRowKeySelect, record.stcode]),
        ]);
      } else {
        const ind = itemsRowKeySelect.findIndex((d) => d === record.stcode);
        const tval = [...itemsRowKeySelect];
        tval.splice(ind, 1);
        setItemsRowKeySelect([...tval]);
        // console.log(ind, itemsRowKeySelect);
      }
    },
  };
  /** setting child component */
    const ButtonModal = (
      <Space direction="horizontal" size="middle">
        <Button onClick={() => handleClose()}>ปิด</Button>
        <Button type="primary" onClick={() => handleConfirm()}>
          ยืนยันการเลือกสินค้า
        </Button>
      </Space>
    );

  return (
    <>
      <Modal
        open={openModal}
        title="เลือกสินค้าที่จะซื้อ"
        afterClose={() => handleClose()}
        onCancel={() => setOpenModel(false)}
        footer={ButtonModal}
        maskClosable={false}
        style={{ top: 20 }}
        width={1200}
        className="modal-buymaterial"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Form.Item label="ค้นหา">
                      <Input
                        ref={inputRef}
                        suffix={<SearchOutlined />}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                        placeholder="ค้นหาชื่อ หรือ รหัส"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChange}
                      checked={checkAll}
                    >
                      <TagItemTypes data={"Check All"} />
                    </Checkbox>
                    <CheckboxGroup
                      options={itemsTypeOption}
                      value={checkedList}
                      onChange={onChange}
                    />
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ minHeight: "60vh" }}>
              <Table
                bordered
                dataSource={modalDataWrap}
                columns={column}
                rowSelection={itemSelection}
                rowKey="stcode"
                pagination={{
                  total: modalDataWrap?.length || 0,
                  showTotal: (_, range) =>
                    `${range[0]}-${range[1]} of ${
                      modalDataWrap?.length || 0
                    } items`,
                  defaultPageSize: 10,
                  pageSizeOptions: [10,25, 35, 50, 100],
                }}
                size="small"
              />
            </Card>
          </Space>
        </Spin>
      </Modal>
    </>
  );
}
